const localhostIp = 'http://192.168.31.34:';
const badIp = 'http://124.222.60.39:';
const shareDomainLocalhost = '192.168.31.34'
const shareDomainLocalhost2 = '192.168.31.141'

// const localhostIp = 'http://192.168.31.25:';
// const badIp = 'http://124.222.60.39:';
// const shareDomainLocalhost = '192.168.31.25'

// const localhostIp = 'http://192.168.2.11:';
// const badIp = 'http://192.168.2.12:';
// const shareDomainLocalhost = '192.168.2.11'

function isProd() {
  return process.env.NODE_ENV === 'production';
}

module.exports = {
  title: '简赢 - 婚纱礼服馆管理系统',

  // /**
  //  * @type {boolean} true | false
  //  * @description Whether fix the header
  //  */
  // fixedHeader: true,

  // /**
  //  * @type {boolean} true | false
  //  * @description Whether show the logo in sidebar
  //  */
  // sidebarLogo: true,

  // activeApp: 'base',
  // isJY: true,

  // shareDomain: isProd() ? '.jianyingkeji.com' : shareDomainLocalhost,
  // shareDomainLijianlifu: isProd() ? '.lijianlifu.com' : shareDomainLocalhost,
  shareDomain: isProd() ? '.lijianlifu.com' : shareDomainLocalhost,
  shareDomainLijianlifu: isProd() ? '.jianyingkeji.com' : shareDomainLocalhost,

  baseEndpoint: isProd() ? 'https://web.jianyingkeji.com' : localhostIp + '9724',


  coreEndpoint: isProd() ? 'https://corebkd.jianyingkeji.com' : badIp + '9282',
  coreAdapterEndpoint: isProd() ? 'https://adapterbkd.jianyingkeji.com' : badIp + '9283',
  coreAdapterJuShiTaEndpoint: isProd() ? 'https://aliExpress6.jianyingkeji.com' : badIp + '80',
  coreMesEndpoint: isProd() ? 'https://mesbkd.jianyingkeji.com' : badIp + '9284',
  coreMmsEndpoint: isProd() ? 'https://mmsbkd.jianyingkeji.com' : badIp + '9285',
  coreLogserverEndpoint: isProd() ? 'https://logbkd.jianyingkeji.com' : badIp + '9286',
  coreFileserverEndpoint: isProd() ? 'https://filebkd.jianyingkeji.com' : badIp + '9287',
  fileserverEndpoint: 'https://files.jianyingkeji.com',
  coreAdapterAmazonEndpoint: isProd() ? 'https://amazonbkd.jianyingkeji.com' : badIp + '9289',
  coreAdapterTaoBaoEndpoint: isProd() ? 'https://taobaobkd.jianyingkeji.com' : badIp + '9290',

  coreWeddingDressHallEndpoint: isProd() ? 'https://lijianbkd.jianyingkeji.com' : badIp + '9291',

};
